import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  overflowContainer: {
    height: pxToRem(20),
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
    color: theme.palette.neutralDark,
  },
  callout: {
    gapSpace: 0,
    calloutWidth: pxToRem(214),
    backgroundColor: theme.palette.neutralWhite,
    minPagePadding: pxToRem(16),
  },
  tooltip: {
    styles: {
      root: { backgroundColor: theme.palette.neutralWhite, padding: 0 },
      subText: {
        backgroundColor: theme.palette.neutralWhite,
        fontSize: pxToRem(12),
        padding: pxToRem(16),
      },
    },
  },
});
